// Created: 2026-08-13
// Updated: 2026-08-13
//
// Shared error type for the PUBLIC fetchers (react-query-pattern-detail, task 1).
//
// The secure transport already throws a status-bearing `ApiError`
// (`src/api/secure/helpers.ts`) while public fetchers historically threw a message-only `Error` and
// discarded the HTTP status. That asymmetry makes the shared status-aware React Query retry
// predicate (`shouldRetryQuery` in `src/queries/queryClient.ts`) impossible: it reads `error.status`
// structurally and must never retry a 4xx.
//
// Slice 1 added this class privately inside `src/api/fetchers/materials.ts`. Slice 2 needs the same
// shape in `patterns.ts`, so it is hoisted here rather than duplicated — one definition means one
// `name`/`status` contract for every public fetcher.
//
// Deliberately NOT re-exported from `src/api/fetchers/index.ts`: consumers read the numeric `status`
// structurally, exactly as they already do for `ApiError`, so no consumer needs the class itself.

/** Error subclass carrying the HTTP status of a failed PUBLIC fetch. */
export class PublicApiError extends Error {
  status: number

  constructor(message: string, status: number) {
    super(message)
    this.name = 'PublicApiError'
    this.status = status
  }
}
